import CreatorProfile from "./CreatorProfile";

export default function GoldieProfile() {
  return (
    <CreatorProfile
      creatorId={14}
      categoryLabel="Angels of ISM"
      onlyMemberzSlug="goldie"
      tags={["Entertainment", "Angels of ISM", "Blood Eclipse", "ISM Media", "On The Scene"]}
    />
  );
}
